/**
 * @ngdoc Controller
 * @name AccessTokensController
 */
(function() {
    'use strict';

    angular.module('vrm.core')
        .controller('AccessTokensController', AccessTokensController);

    /**
     * @constructor
     * @ngInject
     */
    function AccessTokensController($scope, AccessTokensService, vrmNotificationsService, vrmNotificationType, VrmModalService, locale) {
        function _init() {
            AccessTokensService.requestActiveTokens()
                .then(function(response){
                    $scope.activeTokens = response.tokens;
                });
        }

        $scope.createToken = function(){
            var name = $scope.name;
            $scope.name = "";

            AccessTokensService.createToken(name)
                .then(function(response){
                  $scope.token = response.token;
                  _init();
                    VrmModalService.openAccessTokenModal($scope, response.token);
                });
        };


        $scope.revokeToken = function(token) {
            AccessTokensService.revokeToken(token.idAccessToken)
                .then(function(){
                    _init();
                    vrmNotificationsService.add({
                        type: vrmNotificationType.SUCCESS,
                        message: locale.getString("accesstokens.notification_revoke")
                    });
                });
        };

        $scope.currentDate = Date.now();

        _init();
    }

})();
